<template lang="html">

    <div>
        <div class="control">

            <div class="control-label">
                <lang labelKey="PIM-CAMPAIGN-PRODUCT" class="label"></lang>
            </div>

            <div class="control">

                <multiselect
                    :id="randomId"
                    v-model="productSelected"
                    :options="foundProducts"
                    :loading="isSearchingProducts"
                    :custom-label="customProductLabel"
                    :searchable="true"
                    @search-change="asyncFindProduct"
                    @select="onSelectProduct"
                    @remove="onRemoveProduct"
                    :allow-empty="true"
                    selected-label="aktiv"
                    deselect-label="Klick um abzuwählen"
                    select-label="Klick für Auswahl"
                    placeholder="Suche nach Produkt"
                    label="name"
                    track-by="id"
                    :internal-search="false"
                    :limit="4"
                    :options-limit="10"
                    style="margin-bottom:15px; max-width: 450px;" class="small">
                    <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>
                    <span slot="noOptions"></span>

                </multiselect>

            </div>

        </div>

        <form-input inputType="text" v-model="offerPrice" label="PIM-CAMPAIGN-PRODUCT-OFFER_PRICE"></form-input>

    </div>

</template>

<script>
export default {

    props: {
        product: {
            type: Object,
            required: true,
            default: null
        },

    },

    data () {
        return {
            offerPrice: null,
            isSearchingProducts: false,
            foundProducts: [],
            productSelected: null
        }
    },

    computed: {

        randomId() {
            return (((1+Math.random())*0x10000)|0).toString(8).substring(1);
        }

    },

    created() {

        this.productSelected = this.product.id;
        this.offerPrice = this.product.offerPrice;

    },

    methods: {


        customProductLabel({ name, extRef, price }) {
            return name + ' (#'+extRef+'), €'+ price.replace('.',',');
            // parseFloat(str.replace(',','.').replace(' ',''))
        },


        asyncFindProduct(query, i) {

            console.log(i);

            if(query == null || query == "") {
                return;
            }
            this.isSearchingProducts = true;

            let searchData = {
                site: null,
                query: query
            }
            // api/pimProduct?search=mexa&searchFields=extRef,name&fields=name,extRef,site
            // this.axios.get(this.$config.api + 'pimProduct?search='+query+'&searchFields=extRef,name&fields=name,price,extRef,site').then(res => {
            this.axios.post(this.$config.api + 'pimProduct/query', searchData ).then(res => {
                this.foundProducts = res.data.pimProduct;
                this.isSearchingProducts = false;
            })

        },

        onSelectProduct(selectedOption, id) {

            console.log("onSelect: ", selectedOption, id);
            this.$emit('productSelected', { pimProduct: selectedOption.id, offer: 2, offerPrice: this.offerPrice });

        },

        onRemoveProduct(removedOption, id) {

            console.log("removed: ", removedOption, id);

        }


    }
}
</script>

<style lang="css" scoped >

</style>
